import {
  Component,
  ViewEncapsulation,
  input,
  output,
  OnInit,
  computed,
} from '@angular/core';
import { SavedViewsService } from '@/app/modules/saved-views/saved-views.service';
import { SavedViewSelectorComponent } from '@/app/modules/saved-views/saved-view-selector/saved-view-selector.component';
import { LogService } from '@/app/core/services/log.service';

// TODO:  Add functionality to disable the buttons when the state is not dirty.
//        I had to remove that functionality because there is no way to know if
//        the filters are dirty or not right now.  Refactoring to add that functionality
//        took this feature way way way out of scope because the Filter code
//        is overly complicated and generally not good.
@Component({
  selector: 'rdo-saved-view-actions',
  imports: [SavedViewSelectorComponent],
  providers: [LogService],
  template: `
    <rdo-saved-view-selector [gridName]="gridName()" />
    <button
      class="btn btn-secondary btn-actions"
      (click)="clickSaveHandler($event)"
      [disabled]="!isSaveEnabled()"
    >
      <i class="fa fa-fw fa-file-o"></i> Save
    </button>
    <button
      class="btn btn-secondary btn-actions"
      (click)="clickSaveAsHandler($event)"
    >
      <i class="fa fa-fw fa-floppy-o"></i> Save As
    </button>
  `,
  styleUrl: './saved-view-actions.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
})
export class SavedViewActionsComponent {
  public gridName = input<string>();
  public saveClick = output<Event>();
  public saveAsClick = output<Event>();

  private logger = this.logService.getModuleLogger(
    'SavedViews',
    'SavedViewActionsComponent',
    false
  );

  constructor(
    public savedViewsService: SavedViewsService,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    this.logger.info('constructor  called', this.gridName());
  }

  public clickSaveHandler(event: Event): void {
    this.logger.info('clickSaveHandler  called', this.gridName());
    this.saveClick.emit(event);
  }

  public clickSaveAsHandler(event: Event): void {
    this.logger.info('clickSaveAsHandler  called', this.gridName());
    this.saveAsClick.emit(event);
  }

  public isSaveEnabled = computed(() => {
    const isEnabled = this.savedViewsService.getSelectedViewName().length > 0;
    return isEnabled;
  });
}
